import { PrizesService, type PostPrizeAdminRequest } from '@/backend/market'
import { PrizeRepository } from '../../domain/repositories/PrizeRepository'
import { PrizeModel } from '../models/PrizeModel'
import type { PrizeFilterEntity } from '../../domain/entities/PrizeFilterEntity'
import { PrizeFilterModel } from '../models/PrizeFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { PrizeEntity } from '../../domain/entities/PrizeEntity'
import type { CreateUpdatePrizeEntity } from '../../domain/entities/CreateUpdatePrizeEntity'
import { CreateUpdatePrizeModel } from '../models/CreateUpdatePrizeModel'
import { PrizeMiniModel } from '../models/PrizeMiniModel'
import type { PrizeMiniEntity } from '../../domain/entities/PrizeMiniEntity'
import { getCouponByIdCase } from '@/features/coupons/domain/usecases/getCouponByIdUsecase'

export class PrizeRepositoryImpl implements PrizeRepository {
  async getPrizes(
    filterData: PrizeFilterEntity
  ): Promise<PaginateEntity<PrizeMiniEntity[]> | { error: true }> {
    const prizeFilterModel = new PrizeFilterModel(filterData)
    try {
      const response = await PrizesService.getPrizesAdmin(prizeFilterModel)
      const prizeModels = response.items?.map((item) => new PrizeMiniModel(item as PrizeMiniModel))
      const activityLogResponse = new PaginateEntity<PrizeMiniModel[]>(response, prizeModels)

      return activityLogResponse
    } catch {
      return { error: true }
    }
  }
  async getPrize(id: number): Promise<PrizeEntity | { error: true }> {
    try {
      const response = await PrizesService.getPrizeByIdAdmin({ id })
      let coupon = undefined
      if (response.couponId) {
        coupon = await getCouponByIdCase(response.couponId)
      }
      const prizeModel = new PrizeModel({ ...response, coupon })
      return prizeModel
    } catch {
      return { error: true }
    }
  }
  async createPrize(
    prizeData: CreateUpdatePrizeEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdatePrizeModel = new CreateUpdatePrizeModel(prizeData)
    try {
      await PrizesService.createPrizeAdmin({
        requestBody: createUpdatePrizeModel as PostPrizeAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updatePrize(
    id: number,
    prizeData: CreateUpdatePrizeEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdatePrizeModel = new CreateUpdatePrizeModel(prizeData)
    try {
      await PrizesService.updatePrizeAdmin({
        id,
        requestBody: createUpdatePrizeModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deletePrize(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await PrizesService.deletePrizeAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
